// Italian academic-year arithmetic.
import { escapeHTML } from "./dom.js";
import { state } from "../state.js";

export function currentItalianSchoolYear() {
  const now = new Date();
  const utcMonth = now.getUTCMonth() + 1;
  return utcMonth <= 6 ? now.getUTCFullYear() - 1 : now.getUTCFullYear();
}

export function schoolYearOptions(selectedStartYear = currentItalianSchoolYear()) {
  return state.academicYears
    .map((academicYear, index) => `<option value="${academicYear.id}" ${index === 0 ? "selected" : ""}>${escapeHTML(academicYear.name)}</option>`)
    .join("");
}

export function activeGradeLevel() {
  if (!state.profile) return null;
  return state.enrollments.find(item => item.child_profile_id === state.profile.id)?.grade_level || null;
}
